/*
Copyright (C) 2026  Integrated Tech9labs Pvt. Ltd.
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import * as React from "react";
import { observer } from "mobx-react";
import { useNavigate } from "react-router";

import Navigation from "@src/components/modules/NavigationModule/Navigation";
import MainTemplate from "@src/components/modules/TemplateModule/MainTemplate";
import PageHeader from "@src/components/smart/PageHeader";
import LiveMonitorContent from "@src/components/modules/LiveModule/LiveMonitorContent";
import liveStore from "@src/components/modules/LiveModule/LiveStore";
import projectStore from "@src/stores/ProjectStore";

/* /live: every migration and sync running right now, polled every 5 s. */

const LiveMonitorPage = observer(() => {
  const navigate = useNavigate();
  const [now, setNow] = React.useState(Date.now());

  React.useEffect(() => {
    document.title = "Live monitor · SwiftIQ";
    liveStore.start();
    const tick = window.setInterval(() => setNow(Date.now()), 1000);
    return () => {
      liveStore.stop();
      window.clearInterval(tick);
    };
  }, []);

  return (
    <MainTemplate
      navigationComponent={<Navigation currentPage="live" />}
      listNoMargin
      headerComponent={
        <PageHeader
          title="Live monitor"
          subtitle="Every migration and sync running right now."
          onProjectChange={() => liveStore.reset()}
        />
      }
      listComponent={
        <LiveMonitorContent
          entries={liveStore.entries}
          samples={liveStore.samples}
          totals={liveStore.totals}
          failedLast24h={liveStore.failedLast24h(now)}
          projects={projectStore.projects}
          loaded={liveStore.loaded}
          lastUpdated={liveStore.lastUpdated}
          now={now}
          onCreateTransfer={() => navigate("/wizard/migration")}
        />
      }
    />
  );
});

export default LiveMonitorPage;
